export const ONBOARDING_IMG2 =
	'https://ttalkak-test.s3.ap-northeast-2.amazonaws.com/static/image/onboarding/%E1%84%84%E1%85%A1%E1%86%AF%E1%84%81%E1%85%A1%E1%86%A8-%E1%84%8B%E1%85%A9%E1%86%AB%E1%84%87%E1%85%A9%E1%84%83%E1%85%B5%E1%86%BC-2.webp';

export const ONBOARDING_IMG3 =
	'https://ttalkak-test.s3.ap-northeast-2.amazonaws.com/static/image/onboarding/%E1%84%84%E1%85%A1%E1%86%AF%E1%84%81%E1%85%A1%E1%86%A8-%E1%84%8B%E1%85%A9%E1%86%AB%E1%84%87%E1%85%A9%E1%84%83%E1%85%B5%E1%86%BC-3.webp';

export const ONBOARDING_IMG5 =
	'https://ttalkak-test.s3.ap-northeast-2.amazonaws.com/static/image/onboarding/%E1%84%84%E1%85%A1%E1%86%AF%E1%84%81%E1%85%A1%E1%86%A8-%E1%84%8B%E1%85%A9%E1%86%AB%E1%84%87%E1%85%A9%E1%84%83%E1%85%B5%E1%86%BC-5.webp';
